import React from 'react';
import { Button, Column, Margin, Modal, Row } from '@upgrade/react-components';
import { Heading, Text } from '../TypographyPublicSite';
import { LocaleFlag } from './LocaleFlag';
import { LocaleModalHeader } from './styles';
import Link from '../Link';
import { getPathnameForLocale, useLocale } from '../../../utils/locale';

const LocaleSwitcherModal = ({ visible, onClose, locale: selectedLocale }) => {
  const { setLocale, location, locale: currentLocale } = useLocale();
  const { demonym: currentDemonym } = currentLocale || {};
  const { country: selectedCountry, demonym: selectedDemonym } = selectedLocale || {};

  const handleContinueClick = () => {
    setLocale(selectedLocale);
    onClose();
  };

  const pathname = getPathnameForLocale({ locale: selectedLocale, url: location?.pathname });

  return (
    <Modal visible={visible} onClose={onClose} size="small" shouldCloseOnOverlayClick>
      <LocaleModalHeader>
        <Heading size="xxs" as="span">
          Switch to {selectedCountry}
        </Heading>
        <Margin top="xs">
          <LocaleFlag locale={selectedLocale} />
        </Margin>
      </LocaleModalHeader>
      <Margin top="md" />
      <Row>
        <Column xs={12}>
          <Text>
            You&apos;re about to switch the {selectedDemonym} version of this website. Some Upgrade products are not
            currently available to {currentDemonym} residents.
          </Text>
        </Column>
      </Row>
      <Margin top="2xl" />
      <Row>
        <Column xs={12} md={6}>
          <Button emphasis="secondary" fullWidth onClick={onClose}>
            Cancel
          </Button>
          <Margin bottom={{ xs: 'md', md: 'none' }} />
        </Column>
        <Column xs={12} md={6}>
          <Link to={pathname} onClick={handleContinueClick} button fullWidth>
            Continue
          </Link>
        </Column>
      </Row>
    </Modal>
  );
};

export default LocaleSwitcherModal;
